export default {"src":"/_next/static/media/houses-icon-selected.35f95eb2.svg","height":81,"width":94,"blurWidth":0,"blurHeight":0};